import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=3c4a8ec8&scoped=true&"
import script from "./UserList.vue?vue&type=script&lang=js&"
export * from "./UserList.vue?vue&type=script&lang=js&"
import style0 from "./UserList.vue?vue&type=style&index=0&id=3c4a8ec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4a8ec8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c4a8ec8')) {
      api.createRecord('3c4a8ec8', component.options)
    } else {
      api.reload('3c4a8ec8', component.options)
    }
    module.hot.accept("./UserList.vue?vue&type=template&id=3c4a8ec8&scoped=true&", function () {
      api.rerender('3c4a8ec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prevent/basedata/UserList.vue"
export default component.exports